import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchBanksApi,
  addBankApi,
  updateBankApi,
  deleteBankApi,
  fetchDebtsApi,
  addDebtApi,
  updateDebtApi,
  deleteDebtApi,
  fetchExpensesApi,
  addExpenseApi,
  updateExpenseApi,
  deleteExpenseApi,
  fetchCasesApi,
  addCaseApi,
  updateCaseApi,
  deleteCaseApi,
  fetchCashiersApi,
  addCashierApi,
  updateCashierApi,
  deleteCashierApi,
} from "./zreportsApi";

const getErrorMessage = (error, defaultMsg) => {
  if (error.response?.data) {
    const data = error.response.data;
    if (typeof data === "string") return data;
    return data.ExceptionMessage || data.message || data.title || defaultMsg;
  }
  return "Bağlantı hatası";
};

// Combined Initial Fetch Thunk
export const fetchAllZReportDefs = createAsyncThunk(
  "zreports/fetchAllDefs",
  async (branchId, { rejectWithValue, dispatch }) => {
    try {
      const promises = [
        dispatch(fetchBanks()),
        dispatch(fetchDebts()),
        dispatch(fetchExpenses()),
      ];
      if (branchId) {
        promises.push(dispatch(fetchCases(branchId)));
        promises.push(dispatch(fetchCashiers(branchId)));
      }
      await Promise.all(promises);
      return true;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Tanımlar yüklenemedi."));
    }
  }
);

// Banks Thunks
export const fetchBanks = createAsyncThunk(
  "zreports/fetchBanks",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchBanksApi();
      return data.items || [];
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Bankalar alınamadı."));
    }
  }
);

export const addBank = createAsyncThunk(
  "zreports/addBank",
  async ({ title }, { rejectWithValue }) => {
    try {
      const data = await addBankApi(title);
      return data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Banka eklenemedi."));
    }
  }
);

export const updateBank = createAsyncThunk(
  "zreports/updateBank",
  async ({ id, title }, { rejectWithValue }) => {
    try {
      const data = await updateBankApi(id, title);
      return { id, title, data };
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Banka güncellenemedi."));
    }
  }
);

export const deleteBank = createAsyncThunk(
  "zreports/deleteBank",
  async ({ id }, { rejectWithValue }) => {
    try {
      await deleteBankApi(id);
      return id;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Banka silinemedi."));
    }
  }
);

// Debts Thunks
export const fetchDebts = createAsyncThunk(
  "zreports/fetchDebts",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchDebtsApi();
      return data.items || [];
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Borç tanımları alınamadı."));
    }
  }
);

export const addDebt = createAsyncThunk(
  "zreports/addDebt",
  async ({ title }, { rejectWithValue }) => {
    try {
      const data = await addDebtApi(title);
      return data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Borç tanımı eklenemedi."));
    }
  }
);

export const updateDebt = createAsyncThunk(
  "zreports/updateDebt",
  async ({ id, title }, { rejectWithValue }) => {
    try {
      const data = await updateDebtApi(id, title);
      return { id, title, data };
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Borç tanımı güncellenemedi."));
    }
  }
);

export const deleteDebt = createAsyncThunk(
  "zreports/deleteDebt",
  async ({ id }, { rejectWithValue }) => {
    try {
      await deleteDebtApi(id);
      return id;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Borç tanımı silinemedi."));
    }
  }
);

// Expenses Thunks
export const fetchExpenses = createAsyncThunk(
  "zreports/fetchExpenses",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchExpensesApi();
      return data.items || [];
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Gider tanımları alınamadı."));
    }
  }
);

export const addExpense = createAsyncThunk(
  "zreports/addExpense",
  async ({ title }, { rejectWithValue }) => {
    try {
      const data = await addExpenseApi(title);
      return data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Gider tanımı eklenemedi."));
    }
  }
);

export const updateExpense = createAsyncThunk(
  "zreports/updateExpense",
  async ({ id, title }, { rejectWithValue }) => {
    try {
      const data = await updateExpenseApi(id, title);
      return { id, title, data };
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Gider tanımı güncellenemedi."));
    }
  }
);

export const deleteExpense = createAsyncThunk(
  "zreports/deleteExpense",
  async ({ id }, { rejectWithValue }) => {
    try {
      await deleteExpenseApi(id);
      return id;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Gider tanımı silinemedi."));
    }
  }
);

// Cases Thunks
export const fetchCases = createAsyncThunk(
  "zreports/fetchCases",
  async (branchId, { rejectWithValue }) => {
    try {
      const data = await fetchCasesApi(branchId);
      return data.items || [];
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Kasalar alınamadı."));
    }
  }
);

export const addCase = createAsyncThunk(
  "zreports/addCase",
  async ({ title }, { rejectWithValue }) => {
    try {
      const data = await addCaseApi(title);
      return data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Kasa eklenemedi."));
    }
  }
);

export const updateCase = createAsyncThunk(
  "zreports/updateCase",
  async ({ id, title }, { rejectWithValue }) => {
    try {
      const data = await updateCaseApi(id, title);
      return { id, title, data };
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Kasa güncellenemedi."));
    }
  }
);

export const deleteCase = createAsyncThunk(
  "zreports/deleteCase",
  async ({ id }, { rejectWithValue }) => {
    try {
      await deleteCaseApi(id);
      return id;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Kasa silinemedi."));
    }
  }
);

// Cashiers Thunks
export const fetchCashiers = createAsyncThunk(
  "zreports/fetchCashiers",
  async (branchId, { rejectWithValue }) => {
    try {
      const data = await fetchCashiersApi(branchId);
      return data.items || [];
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Kasiyerler alınamadı."));
    }
  }
);

export const addCashier = createAsyncThunk(
  "zreports/addCashier",
  async ({ name, surname }, { rejectWithValue }) => {
    try {
      const data = await addCashierApi(name, surname);
      return data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Kasiyer eklenemedi."));
    }
  }
);

export const updateCashier = createAsyncThunk(
  "zreports/updateCashier",
  async ({ id, name, surname }, { rejectWithValue }) => {
    try {
      const data = await updateCashierApi(id, name, surname);
      return { id, name, surname, data };
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Kasiyer güncellenemedi."));
    }
  }
);

export const deleteCashier = createAsyncThunk(
  "zreports/deleteCashier",
  async ({ id }, { rejectWithValue }) => {
    try {
      await deleteCashierApi(id);
      return id;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Kasiyer silinemedi."));
    }
  }
);
